import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { VideoBlock } from "../../../Shared/components/ContentBlocks/VideoBlock/VideoBlockLayout";
import { slugify } from "../../custom_utils/helpers";
import { ImageBlock } from "./image_block";
import { Block } from "./library/container";
export const RichTextBlock = (p)=>{
    const media = p.media == 'none' ? /*#__PURE__*/ _jsx(_Fragment, {}) : /*#__PURE__*/ _jsx("div", {
        className: `richtext-block__media richtext-block__media--${p.media.position}`,
        children: p.media.media.kind == "image" ? /*#__PURE__*/ _jsx(ImageBlock, {
            ...p.media.media
        }) : p.media.media.kind == "video" ? /*#__PURE__*/ _jsx(VideoBlock, {
            ...p.media.media
        }) : /*#__PURE__*/ _jsx(_Fragment, {})
    });
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "richtext-block",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    "data-anchor": slugify(p.title),
                    className: "richtext-block__title title--l",
                    children: p.title
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `richtext-block__media-container richtext-block__media-container--${p.media != "none" ? p.media.position : ""} `,
                    children: [
                        media,
                        /*#__PURE__*/ _jsxs("div", {
                            className: `richtext-block__container-buttons`,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: p.html
                                    },
                                    className: "richtext-block__container"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "richtext-block__buttons",
                                    children: [
                                        p.primaryActionTitle != "" && /*#__PURE__*/ _jsx("a", {
                                            className: "button",
                                            href: p.primaryActionUrl,
                                            children: p.primaryActionTitle
                                        }),
                                        p.secondaryActionTitle != "" && /*#__PURE__*/ _jsx("a", {
                                            href: p.secondaryActionUrl,
                                            children: p.secondaryActionTitle
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
